module.exports = __webpack_public_path__ + "media/images/social/pinterest-square-brands-c9d9d789bcd26939f09ed51792cd5070.svg";